import { render, staticRenderFns } from "./CreateSaleProforma.vue?vue&type=template&id=30fff3e6"
import script from "./CreateSaleProforma.vue?vue&type=script&lang=js"
export * from "./CreateSaleProforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports